import React, { useEffect, useState } from 'react';
import podiumService from '../../services/podiumService';
import { SortableTh, useSortableRows } from '../../components/tables/SortableTable';

const KIND_LABEL = { earnings_call: 'Earnings call', analyst_call: 'Analyst call', conference: 'Conference', investor_day: 'Investor day', other: 'Other' };

const COLS = [
  { key: 'held_at', type: 'string', get: r => r.held_at || '' },
  { key: 'ticker', type: 'string', get: r => r.ticker },
  { key: 'kind', type: 'string', get: r => r.kind },
  { key: 'fiscal_label', type: 'string', get: r => r.fiscal_label },
  { key: 'duration_min', type: 'number', get: r => r.duration_min },
  { key: 'n_questions', type: 'number', get: r => r.n_questions },
  { key: 'open_reviews', type: 'number', get: r => r.open_reviews },
  { key: 'state', type: 'string', get: r => r.state },
];

export default function PodiumCallsPanel({ onOpen }) {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState(null);
  useEffect(() => { podiumService.getCalls().then(r => setRows(r.data.calls || [])).catch(() => setErr('could not load calls')); }, []);
  const { sorted, toggle, indicator } = useSortableRows(rows, COLS);
  if (err) return <p className="text-sm text-red-500">{err}</p>;
  if (!rows.length) return <p className="text-sm text-gray-500 dark:text-gray-400">No calls yet. The first one arrives when the mini pushes a finished transcript through the Courier connector.</p>;
  return (
    <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-800 overflow-x-auto scrollbar-thin">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-[11px] uppercase tracking-[0.15em] text-gray-400">
            <SortableTh label="Held" colKey="held_at" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Ticker" colKey="ticker" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Kind" colKey="kind" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Period" colKey="fiscal_label" toggle={toggle} indicator={indicator} align="left" />
            <SortableTh label="Min" colKey="duration_min" toggle={toggle} indicator={indicator} />
            <SortableTh label="Questions" colKey="n_questions" toggle={toggle} indicator={indicator} />
            <SortableTh label="Open reviews" colKey="open_reviews" toggle={toggle} indicator={indicator} />
            <SortableTh label="State" colKey="state" toggle={toggle} indicator={indicator} align="left" />
          </tr>
        </thead>
        <tbody>
          {sorted.map(r => (
            <tr key={r.slug} onClick={() => onOpen(r.slug)} className="cursor-pointer border-t border-gray-100 hover:bg-brand-gold/10 dark:border-gray-800">
              <td className="py-2 pr-3 whitespace-nowrap">{r.held_at ? r.held_at.slice(0, 10) : '—'}</td>
              <td className="py-2 pr-3 font-medium">{r.ticker}</td>
              <td className="py-2 pr-3">{KIND_LABEL[r.kind] || r.kind}</td>
              <td className="py-2 pr-3">{r.fiscal_label}</td>
              <td className="py-2 pr-3 text-right tabular-nums">{r.duration_min}</td>
              <td className="py-2 pr-3 text-right tabular-nums">{r.n_questions}</td>
              <td className={'py-2 pr-3 text-right tabular-nums ' + (r.open_reviews ? 'text-amber-500' : 'text-green-500')}>{r.open_reviews}</td>
              <td className="py-2 pr-3">{r.state}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
